/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-28 12:07:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 15:36:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/Components/Search/index.tsx
 */
import React from 'react';

import _Search from 'src/pages/SalesChannelCategory/Components/Search';
import Element from 'src/layout/EditorPageLayout/Element/Elements';

const Search = (props) => {
  const { onSearchHasChange, onSearchTagClose, onSearchChange, getSearch } =
    props;

  return (
    <Element>
      <_Search
        onSearchTagClose={onSearchTagClose}
        onSearchChange={onSearchChange}
        getSearch={getSearch}
        //handleOnSearch={handleOnSearch}
        onSearchHasChange={onSearchHasChange}
      />
    </Element>
  );
};
export default Search;
